export const Translations_hu = {
    "welcomePageTitle": "Válassza ki az Ön",
    "lockerName": "Szekrény neve",
    "lockerId": "Szekrény azonosítója",
    "address": "Cím",
    "selectBtn": "Válasszon easyboxot",
    "select": "Válasszon...",
    "county": "Megye",
    "city": "Város",
    "easyboxNameStreet": "Easybox / utcanév...",
    "backToLockerList": "< Vissza a listához",
    "favouriteLocker": "Megjelölés kedvencként",
    "removeFavouriteLocker": "Kedvenc törlése",
    "openOnGoogleMaps": "Megnyitás a Google térképen",
    "monday": "Hétfő",
    "tuesday": "Kedd",
    "wednesday": "Szerda",
    "thursday": "Csütörtök",
    "friday": "Péntek",
    "saturday": "Szombat",
    "sunday": "Vasárnap",
    "non-stop": "Non-stop",
    "lockerSchedule": "Ütemterv",
    "seeOnMap": "Megtekintés a térképen",
    "locationDisclaimer": "Győződjön meg róla, hogy a helymeghatározás engedélyezve van-e, és engedélyezze a hozzáférést, ha a böngészője/készüléke helymeghatározási engedélyeket kér.",
    "findMeOnMap": "Keressen meg a térképen",
    "searchFilters": "Szűrők keresése",
    "locationError1": "Ez a böngésző nem támogatja a geo-lokációt.",
    "locationError2": "Helymeghatározási hiba: Hozzáférés megtagadvaa!",
    "locationError3": "Helymeghatározási hiba: A pozíció nem érhető el!",
    "clientNotFoundErrorMsg": "Hiba! Ügyfél nem található!",
    "sdkNotFoundErrorMsg": "Hiba! Locker Plugin SDK nem található!",
    "search": "Easybox keresése",
    "searchBy": "Keresés,mint:",
    "easyboxName": "easybox automata neve",
    "street": "Utca",
    "showEasyboxList": "easybox automaták listája",
    "hideEasyboxList": "easybox lista elrejtése ",
    "searchError1": "A keresés ${minLimit} és ${maxLimit} karakter lehet",
    "searchError2": "A keresés nem tartalmazhat speciális karaktert: ${notAllowedSpecial}",
    "home": "Otthon",
    "work": "Munkahely",
    "onlyPOSLockers": "Csak POS terminálos csomagautomaták",
    "advancedFilters": "Szűrők",
    "posAtLocation": "POS a helyszínen:",
    "yes": "Igen",
    "no": "Nem",
    "showAllTheLockersInArea": "Easyboxok megjelenítése",
    "showSelectedLocker": "easybox részletek megjelenítése",
    "hideSelectedLocker": "easybox részletek elrejtése",
    "noEasyboxesFound": "Nem található easybox, kérjük próbálkozzon újból."
}